// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__ecSkB","title":"ClientReferral_title__19Mpw","itemText":"ClientReferral_itemText__ZiAqM"};